import { BaseDTO } from '@/request/apiConfig';
import myAxios from '@/request/myAxios';
import { ChatLogMember, ChatLogQueryDTO, ChatLogReturnDTO, MemberQueryDTO } from '@/dto/chatLog';
import { ChatRequestDTO, PageDTO } from '@/dto/page';

const MAIN_CONTEXT_PATH = import.meta.env.VITE_MAIN_CONTEXT_PATH;

export const apiChatLog = {
  chatLog: {
    list: (query: ChatLogQueryDTO): Promise<BaseDTO<ChatLogReturnDTO>> =>
      myAxios.post(`${MAIN_CONTEXT_PATH}/chat/log/list`, query),
    refresh: (query: ChatRequestDTO): Promise<BaseDTO<number>> =>
      myAxios.post(`${MAIN_CONTEXT_PATH}/chat/log/refresh`, query),
    members: (query: MemberQueryDTO): Promise<BaseDTO<PageDTO<ChatLogMember>>> =>
      myAxios.post(`${MAIN_CONTEXT_PATH}/chat/log/members`, query),
  },
};
